module.exports = __webpack_public_path__ + "img/favorite.fd63df2a.png";